import { render, staticRenderFns } from "./calyrafit-slide.vue?vue&type=template&id=68e538ab&scoped=true&"
import script from "./calyrafit-slide.vue?vue&type=script&lang=js&"
export * from "./calyrafit-slide.vue?vue&type=script&lang=js&"
import style0 from "./calyrafit-slide.vue?vue&type=style&index=0&id=68e538ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e538ab",
  null
  
)

export default component.exports